import {Component} from "react";
import {themableImagePath} from "../utils/imageUtils";
import Price from "./Price";
import ContentHeaderImage from "./ContentHeaderImage";
import GalleryToggleButton from "./GalleryToggleButton";
import RestaurantAvailabilityModal from "./RestaurantAvailabilityModal";
import SuccessModal from "./SuccessModal";
import {setScrollToItineraryEntry} from "../actions/itineraryActions";
import {getHubBaseUrl} from "../utils/configUtils";
import ErrorModal from "./ErrorModal";
import { Trans } from '@lingui/react/macro';
import { getTranslation } from "../utils/translationUtils";

class RestaurantEntry extends Component {
    constructor(props) {
        super(props);

        this.isRestaurantPreselected = this.props.preselectedDetails && this.props.preselectedDetails.serviceProfileId === this.props.restaurant.id;

        this.state = {
            showModal: this.isRestaurantPreselected ? "availability" : "",
            errorMessage: "",
            isExpanded: false,
        };
    }

    showModal = (modalName) => {
        document.body.style.overflow = 'hidden';

        if(modalName === "success") {
            setScrollToItineraryEntry(this.props.date);
        }

        this.setState({
            showModal: modalName,
        });
    };

    hideModal = (modalName) => {
        document.body.style.overflow = 'unset';

        if(modalName === "success") {
            setScrollToItineraryEntry(null);
        }

        this.setState({
            showModal: "",
        });
    };

    showError = (errorMessage) => {
        this.setState({errorMessage});
        this.showModal("error");
    }


    componentWillUnmount() {
        document.body.style.overflow = 'unset';
    }

    render() {
        const description = this.props.descriptions && this.props.descriptions.description;
        const isLongDescription = description && description.length > 200;

        let truncatedDescription = description;
        if (isLongDescription) {
            const splitIndex = description.lastIndexOf(' ', 200);
            const truncateAt = splitIndex !== -1 ? splitIndex : 180;
            truncatedDescription = description.slice(0, truncateAt);
        }

        return (
            <div className="bg-white border border-primary-light my-4">
                <div className="md:flex md:flex-wrap">
                    {/*image*/}
                    <div className="w-full sm:p-4 md:pb-0 md:w-1/2 xl:w-1/3 my-auto">
                        <ContentHeaderImage
                            altText={this.props.restaurant.name.defaultValue + " - header"}
                            resourceId={this.props.restaurant.id}
                            width={400}>

                            <GalleryToggleButton
                                toggleGallery={() => this.props.toggleGallery(this.props.restaurant.id)}
                                toggleExp360Gallery={this.props.toggleExp360Gallery}
                            />

                        </ContentHeaderImage>
                    </div>


                    <div className="p-4 md:w-1/2 md:pl-0 xl:w-1/2 xl:grow sm:pt-0 md:pt-4">

                        {!this.props.isBookingEnabled &&
                        <div className="text-3xl text-primary uppercase">
                            {getTranslation(this.props.restaurant.name)}
                        </div>
                        }

                        {this.props.isBookingEnabled &&
                        <button className="text-3xl text-primary underline uppercase" onClick={() => this.showModal("availability")}>
                            {getTranslation(this.props.restaurant.name)}
                        </button>
                        }

                        <ul className="list-square list-inside my-2">
                            <li>
                                <Trans 
                                    id="open_from_to_location" 
                                    values={{fromTime: this.props.restaurant.fromTime, toTime: this.props.restaurant.toTime, location: this.props.restaurant.location}}
                                >
                                    Open {this.props.restaurant.fromTime} - {this.props.restaurant.toTime}, {this.props.restaurant.location}
                                </Trans>
                            </li>
                        </ul>

                        <div>
                            <span className="xl:hidden">
                                {isLongDescription && !this.state.isExpanded ? (
                                    <span>
                                        {truncatedDescription}...{" "}
                                        <button
                                            onClick={() => this.setState({ isExpanded: true })}
                                            className="text-primary underline text-sm font-semibold cursor-pointer inline focus:outline-none"
                                        >
                                            <Trans id="read_more">Read more</Trans>
                                        </button>
                                    </span>
                                ) : (
                                    <span>
                                        {description}{" "}
                                        {isLongDescription && (
                                            <button
                                                onClick={() => this.setState({ isExpanded: false })}
                                                className="text-primary underline text-sm font-semibold cursor-pointer inline focus:outline-none"
                                            >
                                                <Trans id="read_less">Read less</Trans>
                                            </button>
                                        )}
                                    </span>
                                )}
                            </span>
                            <span className="hidden xl:inline">
                                {description}
                            </span>
                        </div>
                    </div>

                    <div className="bg-primary-lightest-25 px-4 pb-4 w-full leading-normal flex flex-col md:flex-row">
                        <div className="flex flex-col grow md:self-end">
                            <div className="mb-2 md:mt-2 max-w-md">
                                {this.props.descriptions && this.props.descriptions.included}
                                {this.props.restaurant.pdfDownloadAllowed &&
                                <span className="mx-2 md:mx-4">
                                    <a href={`${getHubBaseUrl()}blobs/pdf?reference=${this.props.restaurant.id}`}
                                        className="underline text-primary"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {this.props.isActivity
                                            ? <Trans id="see_more_details">See more details</Trans>
                                            : <Trans id="see_example_menu">See example menu</Trans>
                                        }
                                    </a>
                                </span>
                                }
                            </div>
                            {this.props.descriptions && this.props.descriptions.notes &&
                                <div className="flex items-center max-w-md mr-2 bg-grey-lighter py-2 px-4">
                                    <div className="shrink-0 mr-2">
                                        <img alt="" className="w-6 h-6" src={themableImagePath('infoicon_inverted.svg')} />
                                    </div>
                                    <div className="flex-1">
                                        {this.props.descriptions.notes}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={`text-right leading-none md:self-start mt-4 md:mt-0 shrink-0 ${!this.props.isBookingEnabled ? "w-full md:min-w-[180px] md:max-w-[240px] xl:min-w-[400px]" : ""}`}>
                            <Price preText="from" currencySymbol={this.props.restaurant.currencySymbol} price={this.props.restaurant.fromAdultPrice} postText=" pp"/>
                            {!this.props.isBookingEnabled &&
                                <div className="mt-2 text-sm text-right">
                                    <Trans id="contact_you_later">We’ll contact you when this is available to book</Trans>
                                </div>
                            }

                            {this.props.isBookingEnabled &&
                            <button className="action-button action-button-enabled w-full mt-3" onClick={() => this.showModal("availability")}>
                                <Trans id="book_now">Book Now</Trans>
                            </button>
                            }
                        </div>

                    </div>

                </div>

                {this.state.showModal === "availability"  &&
                    <RestaurantAvailabilityModal
                        restaurant={this.props.restaurant}
                        date={this.props.date}
                        closeModal={() => this.hideModal("availability")}
                        onSuccess={() => this.showModal("success")}
                        onError={(errorMessage) => this.showError(errorMessage)}
                        preselectedDetails={this.isRestaurantPreselected ? this.props.preselectedDetails : false}
                        isActivity={this.props.isActivity}
                    />
                }

                <SuccessModal
                    show={this.state.showModal === "success"}
                    onClose={() => this.hideModal("success")}
                    title={this.props.isActivity ? <Trans id="activity_reservation_title">Activity booking</Trans> : <Trans id="restaurant_reservation_title">Restaurant reservation</Trans>}
                    message={this.props.isActivity ? <Trans id="activity_reservation_added">Activity booking added to your planner</Trans> : <Trans id="restaurant_reservation_added">Restaurant reservation added to your planner</Trans>}
                />

                <ErrorModal
                    show={this.state.showModal === "error"}
                    onClose={() => this.hideModal("error")}
                    title={<Trans id="error">Error</Trans>}
                    message={this.state.errorMessage}
                />

            </div>
        )
    }
}


export default RestaurantEntry;